import { useState, useRef } from 'react';

/* 드래그 정렬 hook — 리스트 인덱스 기반.
   onReorder(fromIndex, toIndex) 콜백 제공.
   반환된 bind(i) 를 각 행에 펼쳐 draggable/onDrag* 핸들러를 연결한다. */
export function useDragSort(onReorder) {
  const dragIdx = useRef(null);
  const [over, setOver] = useState(null);
  return (i) => ({
    draggable: true,
    onDragStart: (e) => { dragIdx.current = i; e.dataTransfer.effectAllowed = 'move'; },
    onDragOver: (e) => { e.preventDefault(); if (over !== i) setOver(i); },
    onDragLeave: () => { if (over === i) setOver(null); },
    onDrop: (e) => { e.preventDefault(); const from = dragIdx.current; if (from != null && from !== i) onReorder(from, i); dragIdx.current = null; setOver(null); },
    onDragEnd: () => { dragIdx.current = null; setOver(null); },
    isDragging: dragIdx.current === i,
    isOver: over === i,
  });
}

export default useDragSort;
